import { render, staticRenderFns } from "./_SlotsNotAvailable.vue?vue&type=template&id=5268c7c4&scoped=true&"
import script from "./_SlotsNotAvailable.vue?vue&type=script&lang=js&"
export * from "./_SlotsNotAvailable.vue?vue&type=script&lang=js&"
import style0 from "./_SlotsNotAvailable.vue?vue&type=style&index=0&id=5268c7c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5268c7c4",
  null
  
)

export default component.exports